import {
  FaMapMarkerAlt,
  FaMap,
  FaCircle,
  FaListUl,
  FaTag,
  FaCreditCard,
  FaFlask,
  FaStore,
  FaCertificate,
  FaUserMd,
  FaMicroscope,
  FaUserShield,
  FaFileAlt,
  FaShareAlt,
  FaCube,
  FaTimesCircle,
  FaMoneyBillWave,
  FaStethoscope,
  FaFileSignature,
  FaBox,
  FaPercent,
  FaEye,
  FaSortAmountDown,
  FaMedkit,
  FaExternalLinkAlt,
  FaVials,
  FaDollarSign,
  FaQuestionCircle,
  FaCommentDots,
  FaCalendarDay,
  FaUser,
  FaInfoCircle,
  FaUsers,
  FaBuilding,
  FaSitemap,
  FaUserTie,
  FaUsersCog,
  FaThLarge,
  FaChartPie,
  FaCalendarTimes,
  FaFileInvoiceDollar,
  FaHospital,
  FaMoneyCheckAlt,
  FaCalendarAlt,
  /* ── NEW ICONS ── */
  FaCalendarCheck,
  FaUserTag,
  FaBullseye,
  FaLayerGroup,
  FaIdCard,
  FaCalculator,
  FaBook,
  FaExchangeAlt,
  FaHandHoldingUsd,
  FaGlobe,
  FaTags,
  FaReceipt,
  FaWallet,
  FaCoins,
  FaCashRegister,
  FaFileContract,
  FaChartLine,
  FaCopy,
  FaDownload,
  FaBoxOpen,
  FaClone,
  FaCheckCircle,
  FaFileExcel,
  FaBookOpen,
  FaTasks,
  FaDatabase,
  FaBarcode,
  FaShoppingCart,
  FaExclamationTriangle,
  FaBullhorn,
  FaCheckDouble,
  FaUserCheck,
  FaUserCog,
  FaTruck,
  FaWarehouse,
  FaChartBar,
  FaChartArea,
  FaFileInvoice,
  FaFileMedical,
  FaSearchDollar,
  FaTrophy,
  FaClock,
  FaBalanceScale,
  FaBacteria,
} from "react-icons/fa";

export const filteredNavBarLinkLists = [
  {
    category: "Doctor OPD",
    links: [
      {
        link: "/doctor-clinic-router",
        name: "Doctor Clinic Router",
        icon: <FaHospital style={{ marginRight: "15px" }} />,
      },
      {
        link: "/doctor-opd-charge-router",
        name: "Doctor OPD Charge Router",
        icon: <FaMoneyCheckAlt style={{ marginRight: "15px" }} />,
      },
      {
        link: "/doctor-schedule-router",
        name: "Doctor Schedule Router",
        icon: <FaCalendarAlt style={{ marginRight: "15px" }} />,
      },
      {
        link: "/doctor-opd-bill-item-router",
        name: "Doctor OPD Bill Item Router",
        icon: <FaFileInvoiceDollar style={{ marginRight: "15px" }} />,
      },
      {
        link: "/doctor-opd-bill-payment-router",
        name: "Doctor OPD Bill Payment Router",
        icon: <FaCreditCard style={{ marginRight: "15px" }} />,
      },
      {
        link: "/doctor-opd-appointment-router",
        name: "Doctor OPD Appointment Router",
        icon: <FaCalendarCheck style={{ marginRight: "15px" }} />,
      },
    ],
  },
  {
    category: "Employees",
    links: [
      {
        link: "/branch",
        name: "Branch",
        icon: (
          <FaBuilding
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/department",
        name: "Department",
        icon: (
          <FaSitemap
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/designation",
        name: "Designation",
        icon: (
          <FaUserTie
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/roles",
        name: "Roles",
        icon: (
          <FaUserShield
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/employee",
        name: "Employee",
        icon: (
          <FaUser
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/employeeType",
        name: "Employee Type",
        icon: (
          <FaUserTag
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/employeeCategory",
        name: "Employee Category",
        icon: (
          <FaUsersCog
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/employeeLeave",
        name: "Employee Leave",
        icon: (
          <FaCalendarTimes
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/leaveLedgerSummary",
        name: "Ledger Summary",
        icon: (
          <FaBook
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/attendance-report",
        name: "Attendance Report",
        icon: (
          <FaCalendarCheck
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/section",
        name: "Section",
        icon: (
          <FaLayerGroup
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/employee-franchise-details",
        name: "Employee Franchise Details",
        icon: (
          <FaIdCard
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/emp-discount-allowed",
        name: "Discount Allowed",
        icon: (
          <FaPercent
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/employee-targets",
        name: "Employee Target",
        icon: (
          <FaBullseye
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
    ],
  },
  {
    category: "Accounts & Finance",
    links: [
      {
        link: "/appointment-cancellations",
        name: "Appointment Cancellations",
        icon: (
          <FaCalendarTimes
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/performing-doctor-charges",
        name: "Doctor Performing Charges",
        icon: (
          <FaStethoscope
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/doctor-ip-calculation",
        name: "Doctor IP Calculation",
        icon: (
          <FaCalculator
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/commission-ledger",
        name: "Commission Ledger",
        icon: (
          <FaBook
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/credit-transfer",
        name: "Credit Transfer",
        icon: (
          <FaExchangeAlt
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/advance-payment",
        name: "Make Advance Payment",
        icon: (
          <FaHandHoldingUsd
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/online-payment-details",
        name: "Online Payment Details",
        icon: (
          <FaGlobe
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/online-payments-and-receive-payment",
        name: "Online Payment Details Type",
        icon: (
          <FaTags
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/appointment-payment",
        name: "Patient Appointment Payment",
        icon: (
          <FaReceipt
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/patient-coordinator-commission",
        name: "Patient Coordinator Commission",
        icon: (
          <FaPercent
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/payment-ledger",
        name: "Payment Ledger",
        icon: (
          <FaBook
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/paymentMode",
        name: "Payment Mode",
        icon: (
          <FaWallet
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/payment-type",
        name: "Payment Type",
        icon: (
          <FaCoins
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/payments",
        name: "Payments",
        icon: (
          <FaMoneyBillWave
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/received-payment",
        name: "Received Payment",
        icon: (
          <FaCashRegister
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
    ],
  },
  {
    category: "Agents / Coordinators",
    links: [
      {
        link: "/patient-coordinator-agents",
        name: "Patient Coordinator Agents",
        icon: (
          <FaUserTie
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/patient-coordinator-agent-onboarding-application",
        name: "Patient Coordinator Agents Onboarding Application",
        icon: (
          <FaFileContract
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/lab-department-wise-coordinator-rates",
        name: "Lab Department Wise Coordinator rates",
        icon: (
          <FaChartLine
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/lab-department-wise-ip-rates",
        name: "Lab Department Wise IP Rates",
        icon: (
          <FaDollarSign
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
    ],
  },
  {
    category: "Doctors Management",
    links: [
      {
        link: "/doctors",
        name: "Doctor Master",
        icon: (
          <FaUserMd
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/doctor-onboarding-application",
        name: "Doctor Onboarding Application",
        icon: (
          <FaFileSignature
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/doctors-degree",
        name: "Doctors Degree",
        icon: (
          <FaCertificate
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/doctors-sepcialization",
        name: "Doctors Specialization",
        icon: (
          <FaStethoscope
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
    ],
  },
  {
    category: "Franchise/Panel Management",
    links: [
      {
        link: "/package-copy-rate",
        name: "Package Copy Rate",
        icon: (
          <FaCopy
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/new-franchise",
        name: "Document & Download",
        icon: (
          <FaDownload
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/franchise",
        name: "Franchise",
        icon: (
          <FaStore
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/franchise-advance-payment-list",
        name: "Franchise Advance Payment",
        icon: (
          <FaHandHoldingUsd
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/view-franchise-rates",
        name: "View Franchise Rates",
        icon: (
          <FaEye
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/view-franchise-package-rates",
        name: "View Franchise Package Rates",
        icon: (
          <FaBoxOpen
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/panel-master",
        name: "Franchise Copy Rates",
        icon: (
          <FaClone
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/panel-master-approval",
        name: "Franchise Copy Rates Approval",
        icon: (
          <FaCheckCircle
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/franchise-investigation-details",
        name: "Franchise Investigation Details",
        icon: (
          <FaFlask
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/franchise-onboarding-application",
        name: "Franchise Onboarding Application",
        icon: (
          <FaFileContract
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/kyc-documents",
        name: "KYC",
        icon: (
          <FaIdCard
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/franchise-copy-rates",
        name: "LIS Franchise Copy Rates",
        icon: (
          <FaExternalLinkAlt
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/test-rate",
        name: "Test Rate",
        icon: (
          <FaTags
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/test-rate-list-excel",
        name: "Test Rate List Excel",
        icon: (
          <FaFileExcel
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
    ],
  },
  {
    category: "Lab Master Data",
    links: [
      {
        link: "/investigation-comment",
        name: "Investigation Comment",
        icon: (
          <FaCommentDots
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/investigation-deliveryDays",
        name: "Investigation Delivery Days",
        icon: (
          <FaCalendarDay
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/investigation-details",
        name: "Investigation Details",
        icon: (
          <FaInfoCircle
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/investigation-help",
        name: "Investigation Help",
        icon: (
          <FaQuestionCircle
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/investigation-interpretation",
        name: "Investigation Interpretation",
        icon: (
          <FaBookOpen
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/investigation-manager",
        name: "Investigation Manager",
        icon: (
          <FaTasks
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/investigation-nabl",
        name: "Investigation NABL",
        icon: (
          <FaCertificate
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/investigation-observation",
        name: "Investigation Observation",
        icon: (
          <FaEye
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/investigation-sequence",
        name: "Investigation Sequence",
        icon: (
          <FaSortAmountDown
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/investigation-template",
        name: "Investigation Template",
        icon: (
          <FaFileAlt
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/investigation-test",
        name: "Investigation/Test",
        icon: (
          <FaFlask
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/lab-department",
        name: "Lab Department",
        icon: (
          <FaThLarge
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/observation",
        name: "Observation Master",
        icon: (
          <FaMicroscope
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/package",
        name: "Package",
        icon: (
          <FaBox
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/sampleType",
        name: "Sample Type",
        icon: (
          <FaVials
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
    ],
  },
  {
    category: "Machine & Instrumentation",
    links: [
      {
        link: "/machine-data",
        name: "Machine Data",
        icon: (
          <FaDatabase
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/observation-host-code",
        name: "Observation Host Code",
        icon: (
          <FaBarcode
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/machine-master",
        name: "Machine Master",
        icon: (
          <FaMicroscope
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
    ],
  },
  {
    category: "Patient Management",
    links: [
      {
        link: "/membership-card",
        name: "Membership Card",
        icon: (
          <FaIdCard
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/membership-orders",
        name: "Membership Orders",
        icon: (
          <FaShoppingCart
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/membership-rates",
        name: "Membership Rates",
        icon: (
          <FaTags
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/patient",
        name: "Patient",
        icon: (
          <FaUser
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/patient-appointment-details",
        name: "Patient Appointment Details",
        icon: (
          <FaCalendarCheck
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
    ],
  },
  {
    category: "Sample & Accession",
    links: [
      // {
      //   link: "/sample-collection",
      //   name: "Sample Collection",
      //   icon: (
      //     <FaStore
      //       style={{
      //         marginRight: "15px",
      //       }}
      //     />
      //   ),
      // },
      {
        link: "/rejected-sample-appointments",
        name: "Sample Rejected Appointments",
        icon: (
          <FaTimesCircle
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/sampleRejectionReason",
        name: "Sample Rejection Reason",
        icon: (
          <FaExclamationTriangle
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/sample-collect-by-barcode",
        name: "Sample Collect By Barcode",
        icon: (
          <FaBarcode
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
    ],
  },
  {
    category: "Admin",
    links: [
      {
        link: "/zone",
        name: "Zone",
        icon: (
          <FaMap
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/area",
        name: "Area",
        icon: (
          <FaMapMarkerAlt
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/circular",
        name: "Circular",
        icon: (
          <FaBullhorn
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/leave-master",
        name: "Leave Master",
        icon: (
          <FaCalendarTimes
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/collection-type",
        name: "Collection Type",
        icon: (
          <FaListUl
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/department-type",
        name: "Department Type",
        icon: (
          <FaSitemap
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/franchise-type",
        name: "Franchise Type",
        icon: (
          <FaBuilding
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/discount-reason",
        name: "Discount Reason",
        icon: (
          <FaPercent
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/organism",
        name: "Organism",
        icon: (
          <FaBacteria
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/document",
        name: "Document",
        icon: (
          <FaFileAlt
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/shareType",
        name: "Share Type",
        icon: (
          <FaShareAlt
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/outsource-investigation",
        name: "Outsource Investigation",
        icon: (
          <FaExternalLinkAlt
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/outsource-lab",
        name: "Outsource Lab",
        icon: (
          <FaExchangeAlt
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/franchise-onboarding-application-approval",
        name: "Franchise Onboarding Application Approval",
        icon: (
          <FaCheckDouble
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/doctor-onboarding-application-approval",
        name: "Doctor Onboarding Application Approval",
        icon: (
          <FaUserCheck
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/patient-coordinator-agent-onboarding-application-approval",
        name: "Patient Coordinator Agent Onboarding Application Approval",
        icon: (
          <FaCheckCircle
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      // {
      //   link: "/panel-master",
      //   name: "Franchise Copy Rates",
      //   icon: (
      //     <FaDollarSign
      //       style={{
      //         marginRight: "15px",
      //       }}
      //     />
      //   ),
      // },
      // {
      //   link: "/estimate",
      //   name: "Estimate",
      //   icon: (
      //     <FaStore
      //       style={{
      //         marginRight: "15px",
      //       }}
      //     />
      //   ),
      // },
      {
        link: "/report-role",
        name: "Report Role",
        icon: (
          <FaUserCog
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/assign-role",
        name: "Assign Report Role",
        icon: (
          <FaUserTag
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
    ],
  },
  {
    category: "Inventory",
    links: [
      {
        link: "/product",
        name: "Product",
        icon: (
          <FaBox
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/product-type",
        name: "Product Type",
        icon: (
          <FaTags
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/vendor",
        name: "Vendor",
        icon: (
          <FaTruck
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/terms-condition",
        name: "Terms Condition",
        icon: (
          <FaFileContract
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/purchase-order",
        name: "Purchase Order",
        icon: (
          <FaShoppingCart
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/stock-in",
        name: "Manage Stocks",
        icon: (
          <FaWarehouse
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
    ],
  },
  {
    category: "Report",
    links: [
      {
        link: "/marketing-person-business-report",
        name: "Marketing Person Business Report",
        icon: (
          <FaChartBar
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/panne-wise-bus-report",
        name: "Pannel Wise Business Report",
        icon: (
          <FaChartPie
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/invoice-report",
        name: "Invoice Report",
        icon: (
          <FaFileInvoice
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/franchise-invoice-report",
        name: "Franchise Invoice Report",
        icon: (
          <FaFileInvoiceDollar
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/medicity-panel-wise-bus-report",
        name: "LIS Panel Wise Business Report",
        icon: (
          <FaChartArea
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/franchise-panel-wise-bus-report",
        name: "Franchise Pannel Wise Business Report",
        icon: (
          <FaChartLine
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/patient-wise-search-report",
        name: "Result Entry",
        icon: (
          <FaFileMedical
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/patient-report",
        name: "Patient Report",
        icon: (
          <FaUser
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/commission-report-ledger",
        name: "Commission Report Ledger",
        icon: (
          <FaBook
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/payment-type-search-report",
        name: "Payment Type Search Report",
        icon: (
          <FaSearchDollar
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/commission-report",
        name: "Commission Report",
        icon: (
          <FaCoins
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/franchise-top-performer",
        name: "Franchise Top Performer",
        icon: (
          <FaTrophy
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/tat-report",
        name: "TAT Report",
        icon: (
          <FaClock
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/tat-graphical-report",
        name: "TAT Graphical Report",
        icon: (
          <FaChartArea
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
    ],
  },
  {
    category: "MIS Report",
    links: [
      {
        link: "/booking-collection-report",
        name: "Booking Collection Report",
        icon: (
          <FaCalendarCheck
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/investigation-wise-report",
        name: "Investigation Wise Report",
        icon: (
          <FaFlask
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/card-collection-report",
        name: "Card Collection Report",
        icon: (
          <FaCreditCard
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/collection-report",
        name: "Collection Report",
        icon: (
          <FaLayerGroup
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/all-payment-report",
        name: "All Payment Report",
        icon: (
          <FaBalanceScale
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/discount-report",
        name: "Discount Report",
        icon: (
          <FaPercent
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
      {
        link: "/outstanding-report",
        name: "Outstanding Report",
        icon: (
          <FaChartLine
            style={{
              marginRight: "15px",
            }}
          />
        ),
      },
    ],
  },
];
